module.exports = __webpack_public_path__ + "img/tw.5f79ec2f.svg";